import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../state/features/userSlice";
import { selectStep } from "../state/features/stepSlice";
import { useNavigate, useParams } from "react-router-dom";
import { CSteps } from "../components/steps/steps";
import { Clock, Message } from "iconsax-react";
import execute from "../requests/frappe";
import { Steps, Button, Checkbox } from "antd";
import ReactQuill from "react-quill";
import moment from "moment";
import { openNotification } from "../utils/notification";
import "react-quill/dist/quill.snow.css";
import { CheckboxValueType } from "antd/es/checkbox/Group";
import { DownloadOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";

export const Certificate = () => {
  const user = useSelector(selectUser);
  const isLoggedIn = !!user;
  const selectedStep = useSelector(selectStep);
  const navigate = useNavigate();
  const params = useParams();
  const [data, setData] = useState<any>("");
  const [comment, setComment] = useState("");
  const defaultCheckedList = ["Comment", "Send SMS"];
  const [checkedList, setCheckedList] =
    useState<CheckboxValueType[]>(defaultCheckedList);
  const [fetchTrigger, setFetchTrigger] = useState(0);

  const { Step } = Steps;

  const contentRef = useRef<HTMLDivElement>(null);
  // const componentRef = useRef(null);
  const pageStyle = "@page { size: 200mm 280mm; margin: 10mm; }";
  let domElements: any = "";

  const handlePrint = useReactToPrint({
    pageStyle: pageStyle,
    content: () => contentRef.current,
    documentTitle: `Certificate-${params.uac}`,
  });

  const handleTextAreaChange = (
    content: any,
    delta: any,
    source: any,
    editor: any
  ) => {
    setComment(content);
  };

  const handleSendComment = async () => {
    if (comment.trim() === "") {
      openNotification("Error", "Comment is empty.", "error");
      return; // Prevent sending the comment
    }

    if (checkedList.length === 0) {
      openNotification(
        "Error",
        "Please select at least one checkbox.",
        "error"
      );

      return; // Prevent sending the comment
    }

    await execute("SEND_COMMENT", {
      evaluation: data?.evaluation_data?.name,
      email: user?.email,
      comment: comment,
      type: checkedList,
      to: data?.webuser?.mobile_number,
    });

    setComment("");
    setFetchTrigger((prev) => prev + 1);
  };

  const onChange = (list: CheckboxValueType[]) => {
    setCheckedList(list);
  };

  const Fetch_Data = async () => {
    const temp_data = await execute("GET_CERTIFICATE_DATA", {
      uac: params?.uac,
      applicant: params?.user,
    });
    setData(temp_data);
  };

  useEffect(() => {
    if (fetchTrigger > 0 || (data === "" && user)) {
      Fetch_Data();
    }
  }, [fetchTrigger, user]);
  return (
    <>
      <head>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.9.3/html2pdf.bundle.min.js"></script>
      </head>
      {isLoggedIn && data && (
        <div className="w-full mt-[1%] bg-general_bg grid grid-cols-3 xl:grid-cols-4">
          <div className=" col-span-4 xl:col-span-3 mr-[1%] mb-[5%]">
            <div className=" flex justify-between items-center">
              <div className=" max-w-[80%] truncate">
                <span
                  className="text-[#00000073] hover:text-blue cursor-pointer"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  Home / Application assigned
                </span>{" "}
                / {data?.evaluation_data?.name}
              </div>
              <button
                className={` flex items-center px-[4%] py-2 rounded-md text-white ${
                  !data?.form_step ||
                  (data?.second_form_raw_data &&
                    JSON.parse(data?.second_form_raw_data)[data?.form_step])
                    ? "bg-blue_btn"
                    : "cursor-not-allowed bg-[#B0C4DE]"
                }`}
                onClick={handlePrint}
                disabled={
                  !data?.form_step ||
                  (data?.second_form_raw_data &&
                    JSON.parse(data?.second_form_raw_data)[data?.form_step])
                    ? false
                    : true
                }
              >
                <DownloadOutlined
                  className=" mr-3
                "
                />{" "}
                Download Certificate
              </button>
            </div>
            <div className="bg-white mt-[1%] mb-[1%] ">
              <div className="p-4 grid md:grid-cols-5 gap-7">
                <p className=" md:grid md:grid-cols-5 col-span-4 font-[700]">
                  Application Name:
                  <span className=" ml-2 col-span-4">{params.app}</span>
                </p>
                <p className=" col-span-1"> UAC: {data?.uac}</p>
              </div>
              <div className=" xsm:p-4 border-y-[1px]">
                <CSteps steps={data?.steps} />
              </div>
              <div className="p-4 border-b-[1px] xsm:flex justify-between">
                <div className=" font-semibold py-1">
                  TODO
                  <span
                    className=" font-normal text-[#494949]"
                    dangerouslySetInnerHTML={{
                      __html: data?.evaluation_data?.req_html_hidden,
                    }}
                  ></span>
                </div>
              </div>
              <div className="p-4 border-b-[1px]">
                <span className=" font-semibold mb-2">Submission Info</span>
                <div className="grid grid-cols-2 mt-5 gap-10">
                  <div className=" col-span-2 md:col-span-1 grid">
                    <span className="font-semibold mb-2">Service</span>
                    <p className=" mb-5 text-[#494949]">
                      {data?.evaluation_data?.service}
                    </p>
                    <span className="font-semibold mb-2">Application</span>
                    <p className="text-[#494949]">
                      {data?.evaluation_data?.submission}
                    </p>
                  </div>
                  <div className=" col-span-2 md:col-span-1 grid">
                    <span className="font-semibold mb-2">Step Name</span>
                    <p className=" mb-5 text-[#494949]">
                      {data?.evaluation_data?.step_name}
                    </p>
                    <span className="font-semibold mb-2">Type</span>
                    <p className="text-[#494949]">
                      {data?.evaluation_data?.type}
                    </p>
                  </div>
                </div>
              </div>
              <div className=" p-4 grid">
                <span className="font-semibold mb-2">User</span>
                <p className=" mb-5 text-[#494949]">{data?.user}</p>
              </div>
            </div>
            <div
              ref={contentRef}
              className=" font-normal text-[#494949]"
              dangerouslySetInnerHTML={{
                __html: data?.certificate,
              }}
            ></div>
          </div>

          <div className=" col-span-4 xl:col-span-1 mt-10 xl:mt-0">
            <div className=" px-3 mb-10 bg-white nxl:mr-14 rounded-md">
              <h2 className=" font-semibold py-4">Officer Comment</h2>
              <div className=" h-72">
                <ReactQuill
                  className=" h-52"
                  theme="snow"
                  value={comment}
                  onChange={handleTextAreaChange}
                />
              </div>
              <Checkbox.Group
                className=" w-[90%] my-3 justify-between"
                value={checkedList}
                onChange={onChange}
              >
                <Checkbox value="Comment">Comment</Checkbox>
                <Checkbox value="Send SMS">Send SMS</Checkbox>
              </Checkbox.Group>
              <Button className=" h-10 my-3 w-full" onClick={handleSendComment}>
                Send Comment
              </Button>
            </div>
            <h2 className="ml-3 mb-8 font-semibold">Activity Log</h2>
            <Steps
              className=" xl:max-h-[400px] xl:overflow-y-scroll no-scrollbar mb-20"
              direction="vertical"
              current={100000}
            >
              {data?.activity_log?.map((log: any) => {
                if (log.data) {
                  return (
                    log.data && (
                      <Step
                        key={log.name}
                        icon={<Clock size={14} />}
                        description={
                          <div className=" bg-white mr-14 rounded-md">
                            {Object.keys(log?.data).map((alter_type: any) => {
                              const wordsToRemove = ["_", "html"];
                              // Create a regular expression pattern by joining the words with '|' to match any of them
                              const pattern = new RegExp(
                                wordsToRemove.join("|"),
                                "gi"
                              );

                              if (log.data[alter_type]?.length > 0) {
                                return (
                                  <div className=" text-black">
                                    <div className=" flex px-4 py-3">
                                      <span className=" font-semibold">
                                        You
                                      </span>
                                      <p className="ml-4 text-gray-500">
                                        {moment(log.creation).fromNow()}
                                      </p>
                                    </div>
                                    <div className=" px-4 h-fit w-fit pb-3 font-semibold flex flex-wrap items-center ">
                                      <span className=" pr-2 font-normal">
                                        {alter_type.replace(pattern, " ")}
                                      </span>
                                      {log.data[alter_type][0].replace(
                                        pattern,
                                        " "
                                      )}
                                      <span className=" px-1 font-normal">
                                        from
                                      </span>
                                      {log.data[alter_type][1]
                                        ? log.data[alter_type][1]
                                        : "None"}
                                      <span className=" px-1 font-normal">
                                        to
                                      </span>
                                      <p
                                        className=" font-normal"
                                        dangerouslySetInnerHTML={{
                                          __html: log.data[alter_type][2],
                                        }}
                                      ></p>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        }
                      />
                    )
                  );
                }

                if (log.content) {
                  return (
                    log.content && (
                      <Step
                        key={log.name}
                        icon={<Message size={14} />}
                        description={
                          <div className=" bg-white mr-14 rounded-md">
                            <div className=" text-black">
                              <div className=" flex px-4 py-2">
                                <span className=" font-semibold">You</span>
                                <p className="ml-4 text-gray-500">
                                  {moment(log.creation).fromNow()}
                                </p>
                              </div>
                              <p
                                className=" px-4 pb-3 font-normal"
                                dangerouslySetInnerHTML={{
                                  __html: log.content,
                                }}
                              />
                            </div>
                          </div>
                        }
                      />
                    )
                  );
                }
              })}
            </Steps>
          </div>
        </div>
      )}
    </>
  );
};
